import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "../__root";

export const settingsProfileRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/profile",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "AuthenticationProfile" */ "@circle-react/components/OnboardingPage/CreateUserProfile/CreateUserProfile"
      ),
    "CreateUserProfile",
  ),
});
